module.exports = __webpack_public_path__ + "img/1.114b72f9.png";